import type { PublicPostSummary } from '@forbiz/contracts'

import { postsApi } from '../lib/posts.js'
import { useAsync } from '../lib/useAsync.js'
import s from './Posts.module.css'

/**
 * 이용안내 — 가이드(GUIDE) 콘텐츠를 순서대로 펼쳐 보여준다. 미뤄뒀던 튜토리얼 페이지.
 * 운영자가 admin에서 글을 올리면 배포 없이 여기 반영된다(정렬 순서 → 최신순).
 * 본문은 상세를 열지 않고 이 화면에서 바로 읽도록 아코디언 없이 스택으로 편다.
 */

function GuideArticle({ id, i }: { id: number; i: number }) {
  const { data } = useAsync(() => postsApi.get(id), [id])
  const post = data?.post
  if (!post) return null
  return (
    <section className={s.guide} style={{ '--i': i } as React.CSSProperties}>
      <h2 className={s.guideTitle}>{post.title}</h2>
      {post.imageUrl ? <img className={s.hero} src={post.imageUrl} alt="" /> : null}
      {post.body ? <div className={s.body}>{post.body}</div> : null}
    </section>
  )
}

export function GuidePage() {
  const { data, loading, error } = useAsync(() => postsApi.list(['GUIDE']), [])
  const items: PublicPostSummary[] = data?.items ?? []

  return (
    <div className={s.page}>
      <header className={s.head}>
        <h1 className={s.title}>이용안내</h1>
        <p className={s.lead}>포비즈를 처음 쓰시나요? 아래 순서만 따라오면 됩니다.</p>
      </header>

      {error ? (
        <p className={s.muted}>{error}</p>
      ) : loading ? (
        <p className={s.muted}>불러오는 중…</p>
      ) : items.length === 0 ? (
        <p className={s.muted}>아직 등록된 안내가 없어요.</p>
      ) : (
        <div className={s.guideList}>
          {items.map((p, i) => (
            <GuideArticle key={p.id} id={p.id} i={i} />
          ))}
        </div>
      )}
    </div>
  )
}
